import { appConstantSettings } from 'srcReact/appConstantSettings'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'
import authHeader from 'srcReact/helpers/auth-header'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import { getCurrentLanguageFromCookie, getDeviceId } from 'srcReact/helpers/utils'

export const authenticationService = {
  checkEmail,
  sendActivationCode,
  validateActivationCode,
  createAccount,
  sendPasswordResetLink,
  checkPasswordResetKey,
  updatePassword,
  getSSOUserInfo,
  getApiSubdomain,
  getServerAccessToken
}

function checkEmail(email) {
  const language = getCurrentLanguageFromCookie()
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: authHeader(0).Authorization }
  }
  const url = `/v2/user/sign-in/check-email?email=${encodeURIComponent(email)}&language=${language}`
  return doRequestAxios(url, requestOptions)
}

function sendActivationCode(email) {
  const language = getCurrentLanguageFromCookie()
  const requestOptions = {
    method: 'POST',
    headers: { Authorization: authHeader(0).Authorization }
  }

  return doRequestAxios(
    `/v2/user/registration/send-activation-code?email=${encodeURIComponent(email)}&language=${language}`,
    requestOptions
  )
}

function validateActivationCode(email, activationCode) {
  const language = getCurrentLanguageFromCookie()
  const requestOptions = {
    method: 'POST',
    headers: { Authorization: authHeader(0).Authorization }
  }
  return doRequestAxios(
    `/v2/user/registration/validate-activation-code?email=${encodeURIComponent(
      email
    )}&activation_code=${activationCode}&language=${language}`,
    requestOptions
  )
}

function createAccount(params, apiSubDomainUrl) {
  const language = getCurrentLanguageFromCookie()
  const deviceId = getDeviceId()
  const formData = new FormData()
  formData.append('email', params.email)
  formData.append('password', params.password)
  formData.append('from_sso', params.fromSSO)
  formData.append('firstname', params.firstname)
  formData.append('lastname', params.lastname)
  if (params.preferred_pronoun) {
    formData.append('preferred_pronoun', params.preferred_pronoun)
  }
  if (params.preferred_pronoun === 'other') {
    formData.append('personalized_pronoun', params.personalized_pronoun)
  }
  if (params.picture_id) {
    formData.append('picture_id', params.picture_id)
  }
  formData.append('is_public', params.is_public)
  formData.append('gender', params.gender)
  formData.append('birthday', params.birthday)
  formData.append('interest_ids', params.interest_ids)
  if (params.workplace_ids) {
    formData.append('workplace_ids', params.workplace_ids)
  }
  if (params.organization_id) {
    formData.append('organization_id', params.organization_id)
  }
  formData.append('language', language)
  formData.append('device_id', deviceId)

  const requestOptions = {
    method: 'POST',
    headers: authHeader(0, ''),
    params: formData
  }

  const url = `/v2/user/registration/add`
  return doRequestAxios(url, requestOptions, appConstantSettings.RETRY_COUNT, apiSubDomainUrl)
}

function sendPasswordResetLink(email) {
  const language = getCurrentLanguageFromCookie()
  const requestOptions = {
    method: 'POST',
    headers: authHeader(0)
  }
  return doRequestAxios(
    `/v2/user/password/send-reset-link?email=${encodeURIComponent(email)}&language=${language}`,
    requestOptions
  )
}

function checkPasswordResetKey(reset_key) {
  const isAuthorized = isUserAuthorized()
  const language = getCurrentLanguageFromCookie()
  const requestOptions = {
    method: 'POST',
    headers: isAuthorized ? authHeader() : authHeader(0)
  }
  let apiUrl = `/v2/user/password/check-reset-key?reset_key=${reset_key}&language=${language}`
  if (isAuthorized) {
    apiUrl = `/v2/user/settings/account/password/check-reset-key?reset_key=${reset_key}`
  }
  return doRequestAxios(apiUrl, requestOptions)
}

function updatePassword(params) {
  const language = getCurrentLanguageFromCookie()
  const formData = new FormData()

  formData.append('reset_key', params.reset_key)
  formData.append('password', params.password)
  formData.append('language', language)

  const requestOptions = {
    method: 'POST',
    headers: authHeader(0, false),
    params: formData
  }
  return doRequestAxios(`/v2/user/password/update`, requestOptions)
}

function getSSOUserInfo(ssoKey) {
  const language = getCurrentLanguageFromCookie()
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: authHeader(0).Authorization },
    params: {
      sso_key: ssoKey,
      language: language
    }
  }
  const url = `/v2/user/sign-in/sso-return`
  return doRequestAxios(url, requestOptions)
}

function getApiSubdomain(orgId) {
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: authHeader(0).Authorization }
  }
  const url = `/v2/organization/api-call-subdomain?id_organization=${orgId}`
  return doRequestAxios(url, requestOptions)
}

function getServerAccessToken(grantType, clientId, clientSecret, scope) {
  const requestOptions = {
    method: 'POST',
    data: {
      grant_type: grantType,
      client_id: clientId,
      client_secret: clientSecret,
      scope
    }
  }
  const url = `/access-token`
  return doRequestAxios(url, requestOptions)
}
